import { getPlatformInstance } from '@/platform'

export interface IWatchdogService {
  start: () => Promise<void>
  stop: () => Promise<void>
  ping: () => Promise<void>
}

export class WatchdogService implements IWatchdogService {
  async start() {
    await getPlatformInstance().watchdog.start()
  }

  async ping() {
    await getPlatformInstance().watchdog.ping()
  }

  async stop() {
    await getPlatformInstance().watchdog.stop()
  }
}
